import React from 'react';
import styled, { css } from 'styled-components';
import { background, darkgrey, lightgrey, warningred } from 'styles/Colors';
import { Arrow } from 'components/ui/SelectList/styles/SelectListStyles';
import { SelectList } from 'components/ui/SelectList/SelectList';
import { ReactComponent as ErrorIcon } from 'images/errorIcon.svg';

export const MultipleErrors = styled.div`
  font-size: 11px;
  width: 65px;
`;

export const SingleError = styled.div`
  font-size: 11px;
`;

export const ExpandIcon = styled.div<{ isExpanded: boolean }>`
  transition: all 0.3s;
  ${(props) =>
    props.isExpanded &&
    css`
      transform: rotate(180deg);
    `}
  svg {
    cursor: pointer;
  }
`;

export const StyledSelectList = styled((props) => <SelectList {...props} />)`
  position: absolute;
  padding: 12px;
  z-index: 100;
  left: 0;
  top: 50px;
  width: 100%;
  font-family: Lato;
  border-radius: 4px;
  background-color: ${background};
  border: 1px solid ${lightgrey};
  ${Arrow} {
    display: none;
  }

  max-height: 188px;
  overflow-y: scroll;
`;

export const Error = styled.div`
  font-size: 13px;
  line-height: 1;
  color: ${darkgrey};

  &:not(:last-child) {
    margin-bottom: 14px;
  }
`;

export const ErrorWrapper = styled.div<{ isFirstPlayInInning: boolean }>`
  display: flex;
  width: 100%;
  align-items: center;
  color: ${darkgrey};
  font-weight: 400;
  margin-top: ${(props) => (props.isFirstPlayInInning ? '18px' : 0)};
`;

export const MultipleErrorsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledErrorIcon = styled((props) => <ErrorIcon {...props} />)`
  margin-right: 6px;
`;
